
import type { EnhancedOffer, SupabaseOffer } from "./types";

export function transformSupabaseOffer(offer: SupabaseOffer): EnhancedOffer {
  // Safely handle seller profile data
  // seller_profiles can be an array or an object, we need to handle both cases
  let sellerProfile;
  
  if (Array.isArray(offer.seller_profiles) && offer.seller_profiles.length > 0) {
    // If it's an array, take the first item
    sellerProfile = offer.seller_profiles[0];
  } else if (offer.seller_profiles && typeof offer.seller_profiles === 'object') {
    // If it's a direct object
    sellerProfile = offer.seller_profiles;
  } else {
    // Fallback to empty object
    sellerProfile = {};
  }

  // Debug the seller profile data
  console.log(`Transforming offer ${offer.id}, seller profile data:`, sellerProfile);
  console.log(`Offer slug: ${offer.slug}, seller profile slug: ${sellerProfile.slug || 'undefined'}`);

  const slug = sellerProfile.slug || undefined;

  return {
    id: offer.id,
    title: offer.title || "Untitled Offer",
    price_cents: offer.price_cents || 0,
    dr: offer.dr || 0,
    da: offer.da || 0,
    traffic_estimate: offer.traffic_estimate || 0,
    link_type: offer.link_type || "",
    turnaround_days: offer.turnaround_days || 0,
    tags: Array.isArray(offer.tags) ? offer.tags : [],
    description: offer.description || "",
    sample_links: Array.isArray(offer.sample_links) ? offer.sample_links : [],
    requirements: Array.isArray(offer.requirements) ? offer.requirements : [],
    seller_profile: {
      name: sellerProfile.name || "Unknown Seller",
      verified: sellerProfile.verified || false,
      slug: slug
    },
    seller_profile_id: offer.seller_profile_id || undefined,
    slug: offer.slug || undefined
  };
}
